import { render, staticRenderFns } from "./FinishLQ.vue?vue&type=template&id=20245622&scoped=true&"
import script from "./FinishLQ.vue?vue&type=script&lang=js&"
export * from "./FinishLQ.vue?vue&type=script&lang=js&"
import style0 from "./FinishLQ.vue?vue&type=style&index=0&id=20245622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20245622",
  null
  
)

export default component.exports